import { Component, OnInit } from '@angular/core';
import { Auth } from '../services/auth.service';
import { MigrationsService } from '../services/migrations/migrations.service'

@Component({
  selector: 'migrations',
  templateUrl: './migrations.component.html',
  styleUrls: ['./migrations.component.css']
})
export class MigrationsComponent implements OnInit {

  constructor(protected migrationsService:MigrationsService, private auth:Auth) { }

  migrations:any
  allMigration:any[]=[]
  newMigration={
    migrationName:""
  }

  loading:boolean=true
  hasSysOpsPermission:boolean=false
  inRequest:boolean=false


  ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    this.migrationsService.get().then((response)=>{
        this.migrations=response
        this.migrations.migrationsInDB.forEach(element => {
          element['run']=false
          this.allMigration.push(element)
        });
        this.migrations.migrationsNotInDB.forEach(element => {
          element['run']=true
          this.allMigration.push(element)
        });
        this.loading=false
    })
  }

  run(migration){
    migration['run']=false
    if (this.inRequest) return
    this.inRequest=true
    let p1 = this.migrationsService.create({
      migrationName:migration.name
    })
    p1.then((respponse)=>{
      this.inRequest=false
      alert("Migration ok")
    })
    p1.catch((reason)=>{
      migration['run']=true
      alert("Couldnt migrate: "+migration.name)
      this.inRequest=false
    })

  }


}



// WEBPACK FOOTER //
// ./src/app/migrations/migrations.component.ts